import { helper as buildHelper } from '@ember/component/helper';
import MiscellaneousUtils from 'mewe/utils/miscellaneous-utils';

let { isDefined } = MiscellaneousUtils;

export default buildHelper(function (value) {
  return isDefined(value[0]);
});
